module.exports = __webpack_public_path__ + "img/gif_sanandres.44154612.gif";